import React from "react";

export default function ProfileIcon({ fill, size, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
    >
      <defs>
        <path
          id="s3wc23chla"
          d="M12 0c3.314 0 6 2.686 6 6s-2.686 6-6 6-6-2.686-6-6 2.686-6 6-6zm0 3c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3zm0 10.5c4.005 0 12 1.995 12 6V24H0v-4.5c0-4.005 7.995-6 12-6zm0 2.85c-4.455 0-9.15 2.19-9.15 3.15v1.65h18.3V19.5c0-.96-4.695-3.15-9.15-3.15z"
        />
      </defs>
      <g fill={"none"} fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <g>
                      <g transform="translate(-484 -396) translate(400 48) translate(32 88) translate(32 144) translate(0 96) translate(20 20)">
                        <path d="M0 0H24V24H0z" />
                        <mask id="iaw7gdqtbb" fill="#fff">
                          <use xlinkHref="#s3wc23chla" />
                        </mask>
                        <use
                          fill="#000"
                          fillRule="nonzero"
                          xlinkHref="#s3wc23chla"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
